/**
 * Template: Heritage template WIP
 * -----------------------------------------------------------------------------
 *
 */
import {load} from '@shopify/theme-sections';
import debounce from 'lodash-es/debounce';

import Swiper from 'swiper';
import {on} from '../helpers/utils';
import breakpoints from '../helpers/breakpoints';

/**
 * DOM selectors.
 */
const selectors = {
  desktopCarousel: '[js-heritage="desktop"]',
  mobileCarousel: '[js-heritage="mobile"]',
  nextSlide: '[js-heritage="next"]',
  prevSlide: '[js-heritage="prev"]',
};

/**
 * Instance globals.
 */
let heritageCarouselDesktop = '';
let heritageCarouselMobile = '';

function init() {
  constructCarousels();
  setEventListeners();
}

const carouselSetting = {
  init: false,
  direction: 'vertical',
  slidesPerView: 1,
  mousewheel: {
    releaseOnEdges: true,
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.heritage__slide--dots',
    type: 'bullets',
    bulletElement: 'span',
    clickable: true,
  },
};

/**
 * Construct carousel objects
 */
function constructCarousels() {
  heritageCarouselDesktop = new Swiper(selectors.desktopCarousel, carouselSetting);
  heritageCarouselMobile = new Swiper(selectors.mobileCarousel, carouselSetting);

  if (window.matchMedia(`(min-width: ${breakpoints.medium})`).matches) {
    heritageCarouselDesktop.init();
  }

  if (!window.matchMedia(`(min-width: ${breakpoints.medium})`).matches) {
    heritageCarouselMobile.init();
  }
}

/**
 * Set listeners.
 */
function setEventListeners() {
  on('resize', debounce(handleResizeEvent, 250));
  sliderNavigation();
}

/**
 * Resize listener to handle sliders based on mq
 */
function handleResizeEvent() {
  if (!window.matchMedia(`(min-width: ${breakpoints.medium})`).matches) {
    heritageCarouselMobile.init();
    return;
  }

  if (typeof (heritageCarouselMobile) !== 'undefined') {
    heritageCarouselMobile.destroy();
  }

  heritageCarouselDesktop.init();
}

/**
 * Next slide listener
 */
function sliderNavigation() {
  const prev = document.querySelectorAll(selectors.prevSlide);
  const next = document.querySelectorAll(selectors.nextSlide);

  prev.forEach((arrow) => {
    arrow.addEventListener('click', () => {
      heritageCarouselMobile.slidePrev();
    });
  });

  next.forEach((arrow) => {
    arrow.addEventListener('click', () => {
      heritageCarouselMobile.slideNext();
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  load('*');
  init();
});
